import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import HomeContext from '../../../routes/context/homeContext';
import { api, homepageUploadDir } from '../../../config'
import { getDynamicTitleByLocale, getDynamicTitleByName } from '../../../helpers/getDynamicTitle';

import s from './SignupGrid.css';
import bt from '../../../components/commonStyle.css';

class SignupGrid extends React.Component {
  render() {
    const { dynamicHomePageSettings, currentLocale } = this.props;
    const homepage = this.context
    const apiEndpoint = api && api.apiEndpoint;

    let allProviderAppData, providerAppData;
    allProviderAppData = getDynamicTitleByName({ dynamicHomePageSettings, name: 'signupGridTitle1' });
    providerAppData = getDynamicTitleByLocale({ dynamicHomePageSettings: allProviderAppData, locale: currentLocale });
    providerAppData = providerAppData?.length > 0 ? providerAppData[0] : allProviderAppData[0];

    return (
      <Container className={s.containerWith}>
        <div className={cx(s.safetyContainer, 'safetyContainerRTL', 'mobileSectionDark')} style={{ backgroundImage: `url(${api.apiEndpoint + homepageUploadDir + homepage.signupGridImage4})` }}>
          <Row className={cx(s.displayFlex, s.reverseColumnXs)}>
            <Col xl={7} md={6} sm={6} xs={12} className={cx(s.responsiveNoMargin)}>
              <div className={cx(s.signUp)}>
                <h3 className={'textWhite'}>
                  {providerAppData?.value}
                </h3>
                <p className={'textWhiteTwo'}>
                  {providerAppData?.description}
                </p>
              </div>
              <div className={cx(bt.paddingTop5, s.responsiveNoPadding)}>
                <div className={cx(s.displayInlineBlock, s.paddingRight, 'paddingRightRTLMb')}>
                  <a href={homepage.signupGridLink2} target="_blank" >
                    <img src={api.apiEndpoint + homepageUploadDir + homepage.signupGridImage2} className={s.appImg} />
                  </a>
                </div>
                <div className={cx(s.displayInlineBlock, s.paddingLeft, 'paddingLeftRTL')}>
                  <a href={homepage.signupGridLink1} target="_blank" >
                    <img src={api.apiEndpoint + homepageUploadDir + homepage.signupGridImage1} className={s.appImg} />
                  </a>
                </div>
              </div>
            </Col>
            <Col xl={5} md={6} sm={6} xs={12} className={s.alignCenter}>
              <img src={api.apiEndpoint + homepageUploadDir + homepage.signupGridImage3} className={s.phoneImg} />
            </Col>
          </Row>
        </div>
      </Container>
    );
  }
}
SignupGrid.contextType = HomeContext
export default withStyles(s, bt)(SignupGrid);
